const Arbitrum = () => (
    <svg
        width='25'
        height='28'
        viewBox='0 0 25 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='arbitrum-icon'
    >
        <path
            d='M12.5784 18.0044L16.4484 23.9739L20.0234 21.9381L14.9413 14.0647L12.5784 18.0044Z'
            fill='white'
        />
        <path
            d='M23.2787 19.5438V17.9119L17.7257 9.4104L15.6622 12.847L21.0237 21.3682L22.9618 20.2643C23.0559 20.1897 23.1328 20.0964 23.1876 19.9905C23.2424 19.8846 23.2737 19.7686 23.2796 19.6499L23.2787 19.5438Z'
            fill='white'
        />
        <path
            d='M0.00697369 21.0825L2.74432 22.6322L11.854 8.27497L10.3077 8.23475C8.99041 8.21592 7.57124 8.55308 6.91999 9.59791L1.74742 17.4816L0.00610352 20.1104V21.0868L0.00697369 21.0825Z'
            fill='white'
        />
        <path
            d='M17.1111 8.27405L13.0364 8.28859L3.81787 23.2397L7.04017 25.0632L7.91692 23.6025L17.1111 8.27405Z'
            fill='white'
        />
        <path
            d='M24.9957 8.25358C24.9774 7.83973 24.8568 7.43648 24.6445 7.07867C24.4321 6.72086 24.1343 6.41924 23.7768 6.19986L13.6484 0.478544C13.2868 0.303932 12.8894 0.213135 12.4865 0.213135C12.0837 0.213135 11.6862 0.303932 11.3246 0.478544C11.2376 0.520474 1.47401 6.08777 1.47401 6.08777C1.33829 6.15177 1.20838 6.22706 1.0857 6.31282C0.769047 6.53465 0.507532 6.82398 0.320724 7.15918C0.133916 7.49438 0.0266519 7.86675 0.00695801 8.24845V20.1061L1.74827 17.4782L1.7326 8.32546C1.73446 8.29243 1.73853 8.25956 1.74479 8.22706C1.7846 8.00994 1.90969 7.81692 2.09305 7.68967C2.14094 7.66057 12.0664 2.01028 12.1004 1.99316C12.2193 1.93613 12.3498 1.90613 12.4821 1.90539C12.6144 1.90465 12.7452 1.93319 12.8648 1.98888L22.8626 7.64089C22.979 7.71359 23.076 7.81269 23.1454 7.92988C23.2148 8.04707 23.2545 8.17892 23.2613 8.31434V19.65C23.2588 19.7676 23.2308 19.8833 23.1791 19.9894C23.1275 20.0955 23.0534 20.1896 22.9618 20.2653L21.0237 21.3691L20.0234 21.9382L16.4484 23.9748L12.823 26.0388C12.6226 26.1085 12.4032 26.1042 12.2057 26.0268L7.91687 23.6017L7.04012 25.0633L10.8954 27.2445L11.2289 27.431C11.3734 27.5106 11.4718 27.5637 11.5066 27.5799C11.829 27.719 12.1776 27.7895 12.5296 27.787C12.8523 27.7886 13.1725 27.7305 13.4734 27.6159L24.0083 21.6259C24.3055 21.3987 24.5483 21.1103 24.7196 20.7809C24.891 20.4514 24.9867 20.0891 25 19.7193L24.9957 8.25358Z'
            fill='white'
        />
    </svg>
);

export default Arbitrum;
